var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPopup)?_c('div',{staticClass:"dialog-wrapper",class:{ overlayOffset: _vm.overlayOffset },on:{"click":_vm.wrapperClick}},[_c('div',{staticClass:"dialog",class:{
            scrollable: _vm.scrollable,
            background: _vm.background,
            'dialog--no-padding': _vm.noPadding,
            'dialog--no-radius': _vm.noRadius,
        },on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default"),(_vm.hasCloseButton)?_c('div',{class:['close', _vm.closeButtonModifier],on:{"click":function($event){return _vm.$emit('close', false)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"times"}})],1):_vm._e()],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }